import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { TaskDuration } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddTaskDuration = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (taskDuration: TaskDuration) =>
      add<TaskDuration>("task-durations", taskDuration),
    {
      onSuccess: (taskDuration) => {
        enqueueSnackbar("Task Duration Added", { variant: "success" });
        queryClient.setQueryData<TaskDuration[]>(
          RQ.TASK_DURATIONS,
          (taskDurations: TaskDuration[] | undefined) => {
            return [...(taskDurations ?? []), taskDuration];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Task Duration Adding Error", { variant: "error" });
      },
    }
  );
};
